import type {PageRouteConfig} from '@router';

import Tracking from 'modules/Tracking/Tracking';

export function createTrackingRoute(): PageRouteConfig {
  return {
    element: <Tracking />,
    layout: {
      title: 'پیگیری ها',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      resolveLink: (ctx) => `/profile/${ctx.selectedVendor?.id}`,
      headerDataKey: 'tracking'
    },
    initialHeaderData: {
      tracking: {icon: '', iconTitle: '', action: null, title: '', badgeNumber: 0}
    }
  };
}
